export enum PresetRatio {
  RATIO_16_9 = "16:9",
  RATIO_9_16 = "9:16",
  RATIO_21_9 = "21:9",
  RATIO_4_3 = "4:3",
  CUSTOM = "CUSTOM"
}

export interface WallConfig {
  cabinetsWide: number;
  cabinetsHigh: number;
  pixelsWide: number;
  pixelsHigh: number;
  targetRatio: PresetRatio;
  // Dual-input custom fields
  customRatio: string;        // e.g., "16:9"
  customDecimal: string;      // e.g., "1.777"
  lastEditedCustom: 'ratio' | 'decimal'; 
  // Hardware Presets
  cabinetSizePreset: string;  // e.g., "500x500"
  pixelPitchPreset: string;   // e.g., "3.9"
  showDecimals: boolean;
}

export interface CalculationResult {
  totalWidth: number;
  totalHeight: number;
  actualRatio: number;
  targetDecimal: number; // The specific target decimal used for calculations
  targetW: number;       // The numerator of the source ratio (e.g. 16)
  targetH: number;       // The denominator of the source ratio (e.g. 9)
  physicalWidthM: number;
  physicalHeightM: number;
  normW_x: number;       // Normalized wall height when width is fixed to targetW
  normX_H: number;       // Normalized wall width when height is fixed to targetH
  fitMode: {
    width: number;
    height: number;
    offsetX: number;
    offsetY: number;
  };
  fillMode: {
    width: number;
    height: number;
    zoom: number;
    lostW: number;
    lostH: number;
  };
  accuracy: number;
}